import {Button} from '../../../../../gori/widgets'
import {usePrintLabels} from '../../hooks'

type PrintLabelButtonProps = {
  batchId: number
  orderIds?: number[]
  onSuccessCallback?: () => void
  onErrorCallback?: (error: any) => void
}
export const PrintLabelButton = ({
  batchId,
  orderIds = [],
  onSuccessCallback,
  onErrorCallback,
}: PrintLabelButtonProps) => {
  const {printLabels, loading} = usePrintLabels({batchId, onSuccessCallback, onErrorCallback})

  return (
    <Button
      className='btn border border-2 border-primary bg-white text-primary h-43px bg-hover-primary-light'
      label={'Print Labels'}
      loading={loading}
      event={() => printLabels(orderIds)}
    />
  )
}
